<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
	@if (data.subtitle) {
		<div class="subtitle">{{ data.subtitle }}</div>
	}

	@for (row of rows.controls; track row; let i = $index) {
		<div class="slot-block">
			<div class="flexrow slot-row" [formGroup]="row">
				<mat-form-field class="time">
					<mat-label>Début</mat-label>
					<input matInput type="time" formControlName="start">
				</mat-form-field>
				<span class="dash">–</span>
				<mat-form-field class="time">
					<mat-label>Fin</mat-label>
					<input matInput type="time" formControlName="end">
				</mat-form-field>
				<mat-form-field class="break">
					<mat-label>Pause</mat-label>
					<input matInput type="number" min="0" step="5" formControlName="break_min"
						matTooltip="Minutes déduites du temps de travail. La personne reste comptée présente dans les effectifs.">
					<span matTextSuffix>mn</span>
				</mat-form-field>
				<span class="worked" [matTooltip]="'Temps de travail, pause déduite'">{{ rowDurationLabel(i) }}</span>
				<button mat-icon-button type="button" aria-label="Supprimer le créneau" (click)="removeRow(i)">
					<mat-icon>delete</mat-icon>
				</button>
			</div>
			@if (dayChips.length > 0) {
				<div class="copy-row">
					<span class="copy-label">Recopier sur :</span>
					@for (c of dayChips; track c.day) {
						<button type="button" class="day-chip" [class.on]="copyDays[i].has(c.day)"
							[matTooltip]="c.full" (click)="toggleCopyDay(i, c.day)">{{ c.initial }}</button>
					}
					<button type="button" class="day-chip all" matTooltip="Du lundi au vendredi" (click)="copyAllWeekdays(i)">L→V</button>
				</div>
			}
		</div>
	}

	@if (rows.length === 0) {
		<div class="no-slot">Journée sans travail — ajoutez un créneau si besoin.</div>
	}

	<button mat-stroked-button type="button" (click)="addRow()">
		<mat-icon>add</mat-icon>&nbsp;Ajouter un créneau
	</button>

	@if (errorMessage) {
		<div class="error">{{ errorMessage }}</div>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="onCancel()">Annuler</button>
	<button mat-flat-button color="primary" type="button" (click)="onValidate()">Valider</button>
</mat-dialog-actions>
